import React from 'react';
import styles from './ProgressBar.module.css';
import { useTranslation } from 'react-i18next';

interface ProgressBarProps {
  progress: number;
  style?: React.CSSProperties;
}

const ProgressBar: React.FC<ProgressBarProps> = ({ progress, style }) => {
  const current = Math.min(Math.max(progress, 0), 100);
  const { t } = useTranslation();

  return (
    <div
      className={styles.progressWrapper}
      style={{...style, '--progress': `${current}%` } as React.CSSProperties}
    >
      <div className={styles.infoBlock}>
        <span className={styles.label}>{t('progressBar.text')}</span>
        <span className={styles.percentage}>
          <span className={styles.percentageValue}>{current}%</span>
        </span>
      </div>
      <div className={styles.bar} />
    </div>
  );
};

export default ProgressBar;
